import React from 'react';

import { flagStyles } from '../settings';

const SvgJE = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2616px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgJE;
